/* ORENOA E3 : actions du module de panier (ajout en un clic, cadre, A2) avec mise à jour du tiroir Horizon. */
(function(){
  var busy = false;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function sectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean).join(',');
  }
  async function run(el, action, lines, send) {
    if (busy) return;
    busy = true; el.disabled = true; el.setAttribute('aria-busy', 'true');
    var box = el.closest('[data-oa-cart]');
    var err = box && box.querySelector('[data-oa-error]');
    if (err) err.hidden = true;
    var ev = null, d = null;
    try { ev = await import('@shopify/events'); } catch (_) { ev = null; }
    try {
      if (ev) {
        d = ev.CartLinesUpdateEvent.createPromise();
        el.dispatchEvent(new ev.CartLinesUpdateEvent({ action: action, context: 'cart', lines: lines, promise: d.promise }));
      }
      var res = await send(sectionIds());
      var json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'cart');
      var cart = (json.token && json.items) ? json : await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      if (d) {
        d.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'orenoa-cart', sourceId: 'orenoa-cart', itemCount: cart.item_count, sections: json.sections, didError: false } });
      } else {
        window.location.reload();
      }
    } catch (e) {
      if (d) {
        try {
          var c2 = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          d.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(c2), detail: { items: c2.items, source: 'orenoa-cart', sourceId: 'orenoa-cart', itemCount: c2.item_count, didError: true } });
        } catch (_) {}
      }
      if (err && box) { err.textContent = box.dataset.error; err.hidden = false; }
      el.disabled = false; el.removeAttribute('aria-busy');
    } finally { busy = false; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var add = t.closest('[data-oa-add]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-oa-add');
      run(add, 'add', [{ merchandiseId: id, quantity: 1 }], function (s) {
        var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1'); if (s) fd.append('sections', s);
        return fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      });
      return;
    }
    var sw = t.closest('[data-oa-swap]');
    if (sw) {
      e.preventDefault();
      var from = sw.getAttribute('data-from'), to = sw.getAttribute('data-to'), q = parseInt(sw.getAttribute('data-qty') || '1', 10) || 1;
      run(sw, 'update', [{ merchandiseId: to, quantity: q }], function (s) {
        var u = {}; u[from] = 0; u[to] = q;
        var body = { updates: u }; if (s) body.sections = s;
        return fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      });
    }
  });
  /* Ouvre le tiroir après un ajout si le réglage « ouverture automatique » du thème n'est pas coché. */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.action !== 'add' || !e.promise) return;
    if (document.querySelector('cart-drawer-component[auto-open]')) return;
    e.promise.then(function (r) {
      if (r && r.detail && r.detail.didError) return;
      var dr = document.getElementById('cart-drawer');
      if (dr && typeof dr.open === 'function' && !dr.isOpen) dr.open();
    }).catch(function () {});
  });
})();
